export var ETableColumnAccessor;
(function (ETableColumnAccessor) {
    ETableColumnAccessor["Type"] = "type";
    ETableColumnAccessor["Model"] = "model";
    ETableColumnAccessor["Definition"] = "definition";
})(ETableColumnAccessor || (ETableColumnAccessor = {}));
